import {
  ON_GET_RESCHEDULE_REQUESTS,
  CANCEL_RESCHEDULE_REQUEST_ERROR,
  GET_CANCEL_RESCHEDULE_REQUESTS,
  GET_CANCEL_RESCHEDULE_REQUEST,
  ADD_RESPONSE_CANCEL_RESCHEDULE_REQUEST
} from "../../actions/types";

const initialState = {
  cancelreschedulerequests: [],
  cancelreschedulerequest: null,
  loading: true,
  error: {},
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ON_GET_RESCHEDULE_REQUESTS:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCEL_RESCHEDULE_REQUESTS:
      return {
        ...state,
        cancelreschedulerequests: payload,
        loading: false,
      };
    case GET_CANCEL_RESCHEDULE_REQUEST:
      return {
        ...state,
        cancelreschedulerequest: payload,
        loading: false,
      };
    case ADD_RESPONSE_CANCEL_RESCHEDULE_REQUEST:
      return {
        ...state,
        cancelreschedulerequest: payload,
        loading: false,
      };
    case CANCEL_RESCHEDULE_REQUEST_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
